import { Box } from "@mui/material";

const SR_ONLY = {
  position: "absolute",
  width: 1,
  height: 1,
  p: 0,
  m: -1,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
  border: 0,
};

export default function TimelineAnnouncement({ children }) {
  return (
    <Box role="status" aria-live="polite" aria-atomic="true" sx={SR_ONLY}>
      {children}
    </Box>
  );
}
